var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "settings-container p-3" }, [
    _c("div", { staticClass: "mb-4" }, [
      _c("h5", { staticClass: "fw-bold" }, [
        _vm._v(_vm._s(_vm.$t("settings.tabs.tabInfo")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted small" }, [
        _vm._v("Configure your application preferences below.")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-list shadow-sm rounded border bg-white" },
      _vm._l(_vm.groupedSettings, function(group, category) {
        return _c("div", { key: category }, [
          _c(
            "div",
            {
              staticClass:
                "bg-light p-2 px-3 border-bottom border-top-0 mt-0 fw-bold text-uppercase small text-primary category-header d-flex justify-content-between align-items-center",
              on: {
                click: function($event) {
                  return _vm.toggleCategory(category)
                }
              }
            },
            [
              _c("span", [
                _c("i", { staticClass: "fa fa-folder-open me-2" }),
                _vm._v(_vm._s(category))
              ]),
              _vm._v(" "),
              _c("i", {
                class: [
                  "fa",
                  !_vm.expandedCategories[category]
                    ? "fa-chevron-right"
                    : "fa-chevron-down"
                ]
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expandedCategories[category],
                  expression: "expandedCategories[category]"
                }
              ]
            },
            _vm._l(group, function(item) {
              return _c(
                "div",
                {
                  key: item.internalId,
                  staticClass:
                    "row align-items-center mx-0 py-3 border-bottom last-child-border-0 hover-row"
                },
                [
                  _c("div", { staticClass: "col-md-5" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label fw-medium mb-0 d-block",
                        attrs: { for: `input-${item.internalId}` }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.name) +
                            "\n                "
                        ),
                        item.helpText
                          ? _c("help-popover", {
                              attrs: {
                                "help-text": item.helpText,
                                group: "settings-help",
                                placement: "right",
                                trigger: "hover",
                                "hover-show-delay": 150,
                                "hover-hide-delay": 3000
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    item.status != null || item.isStatusOk != null
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "mt-1 small d-flex align-items-center gap-1"
                          },
                          [
                            item.isStatusOk != null
                              ? [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge",
                                      class: item.isStatusOk
                                        ? "bg-success"
                                        : "bg-danger"
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          "fa me-1",
                                          item.isStatusOk
                                            ? "fa-check"
                                            : "fa-times"
                                        ]
                                      }),
                                      _vm._v(
                                        "\n\t              " +
                                          _vm._s(
                                            item.isStatusOk ? "OK" : "Error"
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            item.status != null
                              ? _c(
                                  "span",
                                  { staticClass: "text-muted fst-italic" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.status) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { class: _vm.getInputColumnClass(item.type) }, [
                    item.type === _vm.SettingType.Boolean
                      ? _c("div", { staticClass: "form-check form-switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.isChecked,
                                expression: "item.isChecked"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              id: `input-${item.internalId}`,
                              type: "checkbox",
                              role: "switch"
                            },
                            domProps: {
                              checked: Array.isArray(item.isChecked)
                                ? _vm._i(item.isChecked, null) > -1
                                : item.isChecked
                            },
                            on: {
                              change: function($event) {
                                var $$a = item.isChecked,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        item,
                                        "isChecked",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        item,
                                        "isChecked",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(item, "isChecked", $$c)
                                }
                              }
                            }
                          })
                        ])
                      : item.type === _vm.SettingType.Html
                      ? _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.valueMisc,
                                expression: "item.valueMisc"
                              }
                            ],
                            staticClass: "form-control mb-2",
                            attrs: {
                              id: `input-${item.internalId}-title`,
                              type: "text",
                              placeholder: "Title enter here..."
                            },
                            domProps: { value: item.valueMisc },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "valueMisc", $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.value,
                                expression: "item.value"
                              }
                            ],
                            staticClass: "form-control form-control-sm",
                            attrs: {
                              id: `input-${item.internalId}`,
                              rows: "4",
                              placeholder: "Enter here..."
                            },
                            domProps: { value: item.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "value", $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          item.default
                            ? _c("div", { staticClass: "mt-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link btn-sm p-0 text-decoration-none text-muted small",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.togglePreview(
                                          item.internalId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa me-1",
                                        _vm.expandedPreviews[item.internalId]
                                          ? "fa-eye-slash"
                                          : "fa-eye"
                                      ]
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.expandedPreviews[item.internalId]
                                            ? "Hide"
                                            : "Show"
                                        ) +
                                        " Default content\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.expandedPreviews[item.internalId]
                                  ? _c(
                                      "pre",
                                      {
                                        staticClass:
                                          "mt-2 p-2 bg-light border rounded small mb-0 html-pre"
                                      },
                                      [_vm._v(_vm._s(item.default))]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                      : item.type === _vm.SettingType.Image
                      ? _c(
                          "div",
                          { staticClass: "w-100" },
                          [
                            _c("setting-image-uploader", {
                              attrs: { item: item, service: _vm.service },
                              on: {
                                "upload-status-change":
                                  _vm.handleUploadStatusChange
                              }
                            })
                          ],
                          1
                        )
                      : item.type === _vm.SettingType.Xls
                      ? _c("div", { staticClass: "w-100" }, [
                          _c("input", {
                            staticClass: "fa fa-upload me-1",
                            attrs: {
                              id: `input-${item.internalId}`,
                              type: "file",
                              accept: ".xls,.xlsx",
                              disabled: _vm.isAnyUploading
                            },
                            on: {
                              change: function($event) {
                                return _vm.onExcelSelected($event, item)
                              }
                            }
                          })
                        ])
                      : _c(
                          "div",
                          { staticClass: "input-group input-group-sm" },
                          [
                            (item.type === _vm.SettingType.Number
                              ? "number"
                              : "text") === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: `input-${item.internalId}`,
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(item.value)
                                      ? _vm._i(item.value, null) > -1
                                      : item.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = item.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              item,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              item,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(item, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              : (item.type === _vm.SettingType.Number
                                  ? "number"
                                  : "text") === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: `input-${item.internalId}`,
                                    type: "radio"
                                  },
                                  domProps: {
                                    checked: _vm._q(item.value, null)
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(item, "value", null)
                                    }
                                  }
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.value,
                                      expression: "item.value"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: `input-${item.internalId}`,
                                    type:
                                      item.type === _vm.SettingType.Number
                                        ? "number"
                                        : "text"
                                  },
                                  domProps: { value: item.value },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "value",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                          ]
                        )
                  ]),
                  _vm._v(" "),
                  item.type !== _vm.SettingType.Html &&
                  item.type !== _vm.SettingType.Image &&
                  item.type !== _vm.SettingType.Xls
                    ? _c("div", { staticClass: "col-md-4" }, [
                        item.default
                          ? _c("small", { staticClass: "text-muted" }, [
                              _c("span", { staticClass: "opacity-75" }, [
                                _vm._v("Default:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "code",
                                { staticClass: "bg-light px-1 rounded" },
                                [_vm._v(_vm._s(item.default))]
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-4 d-flex justify-content-end" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary px-4",
          attrs: { type: "button", disabled: _vm.isAnyUploading },
          on: { click: _vm.postSettings }
        },
        [
          _c(
            "span",
            {
              staticClass:
                "me-2 d-inline-flex align-items-center justify-content-center"
            },
            [
              _vm.isAnyUploading
                ? _c("Spinner")
                : _c("i", { staticClass: "fa fa-check-circle" })
            ],
            1
          ),
          _vm._v(
            "\n        " +
              _vm._s(_vm.isAnyUploading ? "Saving..." : _vm.$t("btnUpdate")) +
              "\n      "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }